import React from 'react'
import cx from 'classnames'

import SEO from 'components/SEO'
import LayoutProject from 'components/LayoutProject'
import FullWidthImage from 'components/projects/shared/FullWidthImage'
import ProjectSection from 'components/projects/shared/ProjectSection'
import ProjectDetailsText from 'components/projects/shared/ProjectDetailsText'
import ProjectWork from 'components/projects/shared/ProjectWork'

import { PLEXUS } from 'theme/constants'
import projectData from 'data/projects/plexus'
// Next Project
import nextProject from 'data/projects/brcc'

import 'styles/projects/plexus.scss'

/* eslint-disable react/jsx-no-bind */
const PlexusPage = () => {
  const {
    solution,
    customSectionOne,
    customSectionTwo,
    customSectionThree,
    customSectionFour,
    customSectionFive,
    customSectionSix,
  } = projectData

  return (
    <LayoutProject
      theme={PLEXUS}
      projectId={PLEXUS}
      singleColumnOverview
      projectData={projectData}
      nextProject={nextProject}
    >
      <SEO
        title="Plexus - Strategy, Design & Web Dev | Build With Studio"
        description="See our work with Plexus and how Studio can boost your digital products. Whether a startup or enterprise, let's collaborate."
      >
        <link
          rel="canonical"
          href="https://buildwithstudio.com/portfolio/plexus/"
        />
      </SEO>
      <div className="plexus__overview-spacer" />
      <ProjectSection refIndex={2} theme={solution?.theme}>
        <div className="plexus__desktop-image">
          <div className="plexus_image-container --plexus-desktop">
            <FullWidthImage
              imageDesktop={solution?.image.desktop}
              imageMobile={solution?.image.mobile}
              loading="lazy"
            />
          </div>
        </div>
        <ProjectDetailsText
          title={solution?.title}
          paragraphs={solution?.paragraphs}
          titleTheme={solution?.titleTheme}
        />
      </ProjectSection>
      {!!customSectionOne && (
        <ProjectSection refIndex={2} theme={customSectionOne?.theme}>
          <h2
            className={cx('project__section-title', {
              [`--${customSectionOne?.titleTheme}`]:
                !!customSectionOne?.titleTheme,
              '--is-image-title': customSectionOne?.isImageTitle,
            })}
          >
            {customSectionOne?.title}
          </h2>
          <div className="plexus_image-container --plexus-custom-section-one-image">
            <FullWidthImage
              imageDesktop={customSectionOne?.image.desktop}
              imageMobile={customSectionOne?.image.mobile}
              loading="lazy"
            />
          </div>
        </ProjectSection>
      )}
      {!!customSectionTwo && (
        <ProjectSection refIndex={2} theme={customSectionTwo?.theme}>
          <h2
            className={cx(
              'project__section-title',
              'plexus-title-custom-section-two',
              {
                [`--${customSectionTwo?.titleTheme}`]:
                  !!customSectionTwo?.titleTheme,
                '--is-image-title': customSectionTwo?.isImageTitle,
                '--is-centered': customSectionTwo?.isCentered,
              },
            )}
          >
            {customSectionTwo?.title}
          </h2>
          <div className="plexus_image-container --plexus-custom-section-two-image">
            <FullWidthImage
              imageDesktop={customSectionTwo?.image.desktop}
              imageMobile={customSectionTwo?.image.mobile}
              loading="lazy"
            />
          </div>
          <ProjectWork
            projectDescription={customSectionTwo?.description}
            projectParagraphs={customSectionTwo?.paragraphs}
            hasNoTitle
          />
        </ProjectSection>
      )}
      {!!customSectionThree && (
        <ProjectSection refIndex={2} theme={customSectionThree?.theme}>
          <div className="plexus_image-container --plexus-custom-section-three-image">
            <FullWidthImage
              imageDesktop={customSectionThree?.image.desktop}
              imageMobile={customSectionThree?.image.mobile}
              loading="lazy"
            />
          </div>
        </ProjectSection>
      )}
      {!!customSectionFour && (
        <ProjectSection refIndex={2} theme={customSectionFour?.theme}>
          <ProjectWork
            projectDescription={customSectionFour?.description}
            projectParagraphs={customSectionFour?.paragraphs}
            hasNoTitle
          />
        </ProjectSection>
      )}
      {!!customSectionFive && (
        <ProjectSection refIndex={2} theme={customSectionFive?.theme}>
          <ProjectWork
            projectDescription={customSectionFive?.description}
            projectParagraphs={customSectionFive?.paragraphs}
            isCentered={customSectionFive?.isCentered}
            hasNoTitle
            vertical={customSectionFive?.isVertical}
          />
          <div className="plexus_image-container --has-padding-bottom --has-no-padding-top">
            <FullWidthImage
              imageDesktop={customSectionFive?.image.desktop}
              imageMobile={customSectionFive?.image.mobile}
              loading="lazy"
            />
          </div>
        </ProjectSection>
      )}
      {!!customSectionSix && (
        <ProjectSection refIndex={2} theme={customSectionSix?.theme}>
          <h2
            className={cx('project__section-title', {
              '--is-image-title': customSectionSix?.isImageTitle,
              '--is-centered': customSectionSix?.isCentered,
            })}
          >
            {customSectionSix?.title}
          </h2>
          <div className="plexus_image-container --right-aligned --has-padding-bottom --has-small-padding-top">
            <FullWidthImage
              imageDesktop={customSectionSix?.image.desktop}
              imageMobile={customSectionSix?.image.mobile}
              loading="lazy"
            />
          </div>
        </ProjectSection>
      )}
    </LayoutProject>
  )
}
/* eslint-enable react/jsx-no-bind */

export default PlexusPage
